import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Authenticated instance — sends the session cookie with every request.
export const authApi = axios.create({ baseURL: API, withCredentials: true });
